<template>
  <div class="feedback-page">
    <div class="menu-list">
      <div
        class="menu-item acea-row row-between-wrapper"
        @click="$router.push({ path: '/user/complaint_channel' })"
      >
        <div class="menu-left acea-row row-middle">
          <div class="menu-icon menu-icon-complaint">
            <svg viewBox="0 0 48 48" aria-hidden="true">
              <path
                d="M10 8h28c2.2 0 4 1.8 4 4v16c0 2.2-1.8 4-4 4H22l-8 7v-7h-4c-2.2 0-4-1.8-4-4V12c0-2.2 1.8-4 4-4z"
                fill="#fff"
              />
              <circle cx="18" cy="20" r="2.2" fill="#e93323" />
              <circle cx="24" cy="20" r="2.2" fill="#e93323" />
              <circle cx="30" cy="20" r="2.2" fill="#e93323" />
            </svg>
          </div>
          <div class="menu-text">投诉绿色通道</div>
        </div>
        <span class="iconfont icon-xiangyou"></span>
      </div>

      <div
        class="menu-item acea-row row-between-wrapper"
        @click="$router.push({ path: '/user/opinion_feedback' })"
      >
        <div class="menu-left acea-row row-middle">
          <div class="menu-icon menu-icon-suggest">
            <svg viewBox="0 0 48 48" aria-hidden="true">
              <rect x="10" y="8" width="28" height="32" rx="3" fill="#fff" />
              <rect x="15" y="14" width="18" height="2.5" rx="1.2" fill="#4a90e2" />
              <rect x="15" y="21" width="18" height="2.5" rx="1.2" fill="#4a90e2" />
              <rect x="15" y="28" width="12" height="2.5" rx="1.2" fill="#4a90e2" />
              <path
                d="M30 30l8 8-3 1-1 3-8-8 4-4z"
                fill="#fff"
                stroke="#4a90e2"
                stroke-width="1.5"
              />
            </svg>
          </div>
          <div class="menu-text">意见反馈</div>
        </div>
        <span class="iconfont icon-xiangyou"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Feedback"
};
</script>

<style scoped>
.feedback-page {
  background-color: #f5f5f5;
  padding: 0.24rem 0.2rem;
  box-sizing: border-box;
  overflow: hidden;
}

.menu-list {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.menu-item {
  background-color: #fff;
  border-radius: 0.12rem;
  padding: 0.34rem 0.3rem;
}

.menu-left {
  flex: 1;
  min-width: 0;
}

.menu-icon {
  width: 0.72rem;
  height: 0.72rem;
  border-radius: 0.12rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.menu-icon svg {
  width: 0.48rem;
  height: 0.48rem;
  display: block;
}

.menu-icon-complaint {
  background: linear-gradient(135deg, #ff6b6b 0%, #e93323 100%);
}

.menu-icon-suggest {
  background: linear-gradient(135deg, #6eb5ff 0%, #4a90e2 100%);
}

.menu-text {
  margin-left: 0.24rem;
  font-size: 0.3rem;
  color: #282828;
}

.menu-item .icon-xiangyou {
  font-size: 0.26rem;
  color: #c8c8c8;
}
</style>
